import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { getEventTypeLabels } from 'pages/MaintenancePage/helpers/getEventTypeLabels';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { SERVICE_EVENT_TYPES, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const EventTypeSelector: FunctionComponent<Props> = ({
    className = '',
    onSelect,
    selectedEventType,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const eventTypeLabels = getEventTypeLabels(t);

    return (
        <VerticalContainer className={`${styles.eventTypeSelector} ${className}`} testId={testId}>
            <Wrapper className={styles.label}>{t.LOG_SERVICE_EVENT_TYPE}</Wrapper>

            <HorizontalContainer className={styles.options}>
                {SERVICE_EVENT_TYPES.map(eventType => {
                    const activeClass = eventType === selectedEventType ? styles.isActive : '';

                    return (
                        <Wrapper
                            className={`${styles.option} ${activeClass}`}
                            key={eventType}
                            onClick={() => onSelect({ eventType })}
                            testId={`${testId}-${eventType}`}>
                            {eventTypeLabels[eventType]}
                        </Wrapper>
                    );
                })}
            </HorizontalContainer>
        </VerticalContainer>
    );
};

export default EventTypeSelector;
